import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import Div from '../../common/div';
import Typography from '../../common/typography';
const PricingLine = ({ duration, monthlyPrice, yearlyPrice, }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    return (_jsx(Div, { flex: "row", align: "center", justify: "left", style: { padding: theme.spacing.sm, paddingLeft: 0 }, children: _jsxs(Div, { flex: "row", gap: theme.spacing.sm, align: "end", fitContent: true, children: [_jsx(Typography, { elementTheme: "h2", children: ['monthly', 'one_time'].includes(duration)
                        ? monthlyPrice
                        : yearlyPrice }), duration !== 'one_time' && (_jsx(Typography, { elementTheme: "overline", color: theme.colors.grey_2, children: t(`plansDurations|${duration}`).toUpperCase() }))] }) }));
};
export default PricingLine;
